import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AIConversationsVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.AIConversationsInput>;
}>;

export type AIConversations = {
  aiConversations: {
    edges: Array<{
      node: Pick<
        Types.AIConversation,
        | 'id'
        | 'title'
        | 'private'
        | 'saved'
        | 'canEdit'
        | 'isOwner'
        | 'isScheduled'
        | 'scheduledPromptId'
        | 'alias'
        | 'aliasType'
        | 'createdAt'
        | 'updatedAt'
        | 'firstUserPrompt'
      > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
    }>;
    pageInfo: Pick<Types.CursorBasedPaginationPageInfo, 'hasNextPage' | 'endCursor'>;
  };
};

export const AIConversationsDocument = gql`
  query AIConversations($input: AIConversationsInput) {
    aiConversations(input: $input) {
      edges {
        node {
          id
          title
          private
          saved
          canEdit
          isOwner
          isScheduled
          scheduledPromptId
          alias
          aliasType
          createdAt
          updatedAt
          createdBy {
            ...ActorTeaser
          }
          firstUserPrompt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ActorTeaser}
`;

/**
 * __useAIConversations__
 *
 * To run a query within a React component, call `useAIConversations` and pass it any options that fit your needs.
 * When your component renders, `useAIConversations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAIConversations({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAIConversations(
  baseOptions?: Apollo.QueryHookOptions<AIConversations, AIConversationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AIConversations, AIConversationsVariables>(
    AIConversationsDocument,
    options,
  );
}
export function useAIConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AIConversations, AIConversationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AIConversations, AIConversationsVariables>(
    AIConversationsDocument,
    options,
  );
}
export function useAIConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AIConversations, AIConversationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AIConversations, AIConversationsVariables>(
    AIConversationsDocument,
    options,
  );
}
export type AIConversationsHookResult = ReturnType<typeof useAIConversations>;
export type AIConversationsLazyQueryHookResult = ReturnType<typeof useAIConversationsLazyQuery>;
export type AIConversationsSuspenseQueryHookResult = ReturnType<
  typeof useAIConversationsSuspenseQuery
>;
export type AIConversationsQueryResult = Apollo.QueryResult<
  AIConversations,
  AIConversationsVariables
>;
export function mockAIConversations({
  data,
  variables,
  errors,
}: {
  data: AIConversations;
  variables?: AIConversationsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AIConversationsDocument, variables },
    result: { data, errors },
  };
}
